import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { SecondaryAlert } from 'kagr-ui';
import * as React from 'react';
import * as styles from './segment-results.module.scss';

interface Props {
  total: number;
  included: number;
  excluded: number;
  isLoading: boolean;
  isError?: boolean;
  errorMessage?: string;
  isStale?: boolean;
}

const SegmentResults = ({ total, included, excluded, isLoading, isError, errorMessage, isStale }: Props) => {
  return (
    <div className={clsx(styles.segmentResultsRoot, isStale && styles.previousData)}>
      {isError && <SecondaryAlert type="error" message={errorMessage || ''} />}
      {isLoading && <CircularProgress size="1em" classes={{ root: styles.loading }} />}
      <table className={styles.results}>
        <thead hidden>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{included.toLocaleString()}</td>
            <td>included</td>
          </tr>
          <tr>
            <td>{excluded.toLocaleString()}</td>
            <td>excluded</td>
          </tr>
          <tr>
            <td>{total.toLocaleString()}</td>
            <td>total customers in segment</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default SegmentResults;
